export class RegExps {
  public static NOT_START_WITH_ZERO: RegExp = /^0\d.*$/;
  public static NOT_NUMBERS: RegExp = /\D/g;
  public static THOUSAND_DELIMITER: RegExp = /\d(?=(\d{3})+$)/g;
  public static NOT_LETTERS: RegExp = /[^a-zñÑ]/gi;
  public static readonly NOT_LETTERS_WITH_APOSTROPHE: RegExp = /[^a-zñÑ']/gi;
  public static readonly NOT_MORE_THAN_TWO_REPEATED: RegExp = /(.)\1{2,}/i;
  public static NOT_LETTERS_NOT_SPACE: RegExp = /[^a-z ]/gi;
  public static NOT_LETTERS_NOT_SPACE_NOT_AMPERSAND: RegExp = /[^a-z &]/gi;
  public static COMPANY_NAME: RegExp = /[`´¨]|[\u0300-\u036f]/gi;
  public static readonly COMPANY_NAME_CHARACTERS: RegExp =
    /[^a-zA-Z0-9ñÑ&\-.'#*_/ ]/g;
  public static DIACRITICAL_MARKS: RegExp = /[\u0300-\u036f]/gi;
  public static readonly NEW_EMAIL: RegExp =
    /^[a-zÑñ][\w.&Ññ-]{0,63}@[a-z\d]{4,181}\.([a-z]{2,4})(\.([a-z]{2,4}))?$/i;
  public static TWO_POINTS: RegExp = /(\.)\1/i;
  public static readonly REPEAT_NUMBER_2_TO_7: RegExp = /^(\d)(?!\1{6})\d{6}$/;
  public static FIRST_POINT: RegExp = /^\./;
  public static LAST_POINT: RegExp = /\.$/;
  public static readonly ADDRESS: RegExp = /[^a-z0-9 #/Ññ-]/gim;
  public static DOCUMENT_FILE_EXTENSION: RegExp =
    /^data:(image\/jpeg|image\/png|application\/pdf);base64,([^\s]+)/;
  public static readonly NO_MORE_THAN_THREE_CHARS: RegExp =
    /(?!i)([a-hj-z])\1{2,}/i;
  public static readonly NOT_MORE_THAN_TWO_LETTERS_EXCEPT_I: RegExp =
    /(?!i|[1-9])(.)\1{2,}/i;
  public static DELIVERY_ADDRESS: RegExp = /[^a-zA-Z0-9 #/,-]/g;
}
